import React from 'react';
import {format} from "date-fns";
import {de} from "date-fns/locale";

const SignupConfirm = ({ apartment, viewings, prevStep, nextStep, setStep, endForm, handleChange, values, focusedTitleRef }) => {

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>
			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Zusammenfassung</span></h1>

			<div>
				<h3>Teilnahme an Auslosung für Besichtigungtermin(e)</h3>
				<p>
				{
					viewings.map((viewing, index) => {
						if(values.dates.includes(viewing.viewingId.toString())) {
							return (
								<span key={`viewing-${index}`}>
									{format(new Date(viewing.viewingMeta.dateStart), "EEEE, dd. MMMM yyy", {locale: de})}, zwischen {format(new Date(viewing.viewingMeta.dateStart), "HH:mm", {locale: de})} und {format(new Date(viewing.viewingMeta.dateEnd), "HH:mm", {locale: de})} Uhr <br/>
								</span>
							)
						}
					})
				}
				</p>
			</div>

			<div>
				<h3>Wieso suchen Sie eine neue Wohnung?</h3>
				<p>{ values.reason }</p>
			</div>

			<div>
				<h3>Ihre Angaben</h3>
				<div className="custom-list-items">
					<ul>
						<li><b>{ (values.peopleCount == 1) ? values.peopleCount  + ' Person' : values.peopleCount + ' Personen' }</b> { (values.peopleCount == 1) ? 'soll' : 'sollen' } in der Wohnung leben.</li>
						<li>Das monatliche Bruttohaushaltseinkommen liegt  <b>{ values.recommendedIncome == 'yes' ? 'über' : 'unter' } Fr. { Math.ceil((apartment.meta.rentPerMonth / 30 * 100).toFixed() / 50)*50 }.–</b></li>
						{(() => {
							switch (values.hasCats) {
								case 'outdoors':
									return (<li>Ich <b>habe Katzen</b>, die Auslauf benötigen</li>)
								case 'indoors':
									return (<li>Ich <b>habe Katzen</b>, die in der Wohnung bleiben.</li>)
								case 'no':
									return (<li>Ich <b>habe keine Katzen</b></li>)
								default:
									return null
							}
						})()}
					</ul>
				</div>
				<br />
			</div>

			<div>
				<h3>Ihre Kontaktdaten</h3>
				<p>
					{ values.firstname } { values.lastname }<br />
					{ values.street } { values.street_nr }<br />
					{ values.zip } { values.place }<br />
					{ values.email }<br />
					{ values.phone }
				</p>
			</div>



			{Object.keys(values.flatmates).length > 0 &&
			<div>
				<h3>Personen, die mit Ihnen einziehen</h3>
				<div>
					<p>
						{
							Object.keys(values.flatmates).map((flatemate) => {
								return (
									<span>
										{ values.flatmates[flatemate].firstname } { values.flatmates[flatemate].lastname }<br />
									</span>
								)
							})
						}
					</p>
				</div>
			</div>
			}


			{values.comment !== '' &&
				<div>
					<h3>Das möchten Sie uns mitteilen</h3>
					<div>
						<p>{ values.comment }</p>
					</div>
				</div>
			}


			<div className="d-flex justify-content-between mt-5 flex-row-reverse">
				<button onClick={ endForm } className="btn btn-secondary">Jetzt abschicken</button>
				<button onClick={ Previous } className="btn btn-secondary btn-back">Zurück</button>
			</div>
        </section>
    )
}

export default SignupConfirm
